import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { getDate } from "utils/formatDate";
import choVayConst, { LaiSuatText2 } from "constants/choVayConst";
import { formatNumber } from "utils/currencyFormat";
import { pushNotification } from "utils/notifications";
import TatToanChoDuyetApi from "../../../../service/tatToanChoDuyetApi";
// import {
//     getListTatToanChoDuyet,
//     updateDataSearch,
// } from "../../../../actions/DanhSachTatToanChoDuyet";
const ThongTinLichSu = ({ show, onHide, item }) => {
  const dispatch = useDispatch();
  // const listTatToanChoDuyetFull = useSelector(
  //     (state) => state.listTatToanChoDuyetFull
  // );
  const dataSearch = useSelector((state) => state.dataSearchTatToanChoDuyet);

  const [hopDongLichSu, setHopDongLichSu] = useState([]);
  useEffect(() => {
    TatToanChoDuyetApi.lichSuDuyetTatToan(item.TatToanChoDuyetID).then(
      (response) => {
        setHopDongLichSu(response.data.List);
      }
    );
  }, []);

  return (
    <Modal
      show={show}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right"></span> Lịch sử duyệt tất toán hợp
          đồng
        </h4>
        <button type="button" className="close-popup-new" onClick={onHide}>
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div
                aria-labelledby="heading61"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <ul className="list-detailHD">
                          <li>
                            Hợp đồng: <b>{item.Code}</b>
                          </li>
                          <li>
                            Ngày tất toán: <b>{getDate(item.Time)}</b>
                          </li>
                          <li>
                            Người tạo: <b>{item.UserName}</b>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="list-detailHD">
                          <li>
                            Số tiền tất toán: <b>{formatNumber(item.Value)}</b>
                          </li>
                          <li>
                            Phí khác: <b>{formatNumber(item.OtherFee)}</b>
                          </li>
                          <li>
                            Tổng tiền tất toán:{" "}
                            <b className="color-do-bold">
                              {formatNumber(item.Value + item.OtherFee)}
                            </b>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-mobile sticky-table-bh2 table-mobile-hover">
                <div className="custom-table-wrapper">
                  <div className="table-headers">
                    <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                      <p className="text-center">STT</p>
                    </div>
                    <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                      <p className="text-center">Ngày thực hiện</p>
                    </div>
                    <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                      <p className="text-center">Người thực hiện</p>
                    </div>
                    <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                      <p className="text-center">Thao tác</p>
                    </div>
                    <div className="custom-table-header flex-basis-45 flex-basis-45-sm">
                      <p className="text-center">Ghi chú</p>
                    </div>
                  </div>

                  <div className="custom-table-body">
                    {hopDongLichSu.map((item, index) => (
                      <div className="custom-table-row">
                        <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
                          <span className="mobile-column-name">STT</span>
                          <div className="center-wrapper">
                            {item.BuocDuyet > 0 && (
                              <span className="buocduyet">{index + 1}</span>
                            )}
                          </div>
                        </div>
                        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
                          <span className="mobile-column-name">
                            Ngày thực hiện
                          </span>
                          <div className="center-wrapper">
                            <p className="text-center">
                              {getDate(item.NgayDuyet)}
                            </p>
                          </div>
                        </div>

                        <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
                          <span className="mobile-column-name">
                            Người thực hiện
                          </span>
                          <div className="center-wrapper">
                            <p className="text-left">
                              <span>{item.NguoiDuyet}</span>
                            </p>
                          </div>
                        </div>
                        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
                          <span className="mobile-column-name">Thao tác</span>
                          <div className="center-wrapper">
                            <p className="text-center">
                              {item.Loai === 1 && (
                                <span>
                                  {item.TrangThai === 1 ? (
                                    <>Duyệt</>
                                  ) : (
                                    <>Không duyệt</>
                                  )}
                                </span>
                              )}
                              {item.Loai === 0 && <>Cập nhật</>}
                            </p>
                          </div>
                        </div>
                        <div className="custom-table-cell flex-basis-45 flex-basis-45-sm">
                          <span className="mobile-column-name">Ghi chú</span>
                          <div className="center-wrapper">
                            <p className="text-left">
                              <span>{item.GhiChu}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
export default ThongTinLichSu;
